var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-badge align-self-center",class:_vm.elementClass,attrs:{"data-testid":_vm.TEST_ID}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }